import CalendarCheckIcon from "../icons/CalendarCheckIcon";
import Link from "next/link";
import SharedHomeHeader from "./SharedHomeHeader";
import { CreateEventButton } from "../CreateEventModal";
import {
    GetCommunitiesToHost,
    GetCurrentUserProfile,
} from "~/app/beta/events/create/actions";
import { useHomePageRenderStore } from "~/state/store";

type Props = {
    user: GetCurrentUserProfile;
    communities: GetCommunitiesToHost;
    _followerCount?: number;
};

const EventsHeader = ({ user, communities, _followerCount }: Props) => {
    const { tab, setTab } = useHomePageRenderStore();
    const followerCount = !!_followerCount ? _followerCount : 0;
    const followerText = getFollowerText(followerCount);

    const title = "Host events on your personal calendar or in a community";
    const smallTitle = "Host events";

    const subTitle = (
        <>
            You have{" "}
            <span
                className="underline hover:cursor-pointer"
                onClick={() => setTab("people")}
            >
                {followerCount.toLocaleString("en-US")}
            </span>{" "}
            {followerText} to invite — gain more by hosting events in a{" "}
            <Link href="/discovery/communities" className="underline">
                community
            </Link>
            .
        </>
    );

    const smallSubTitle = `You have ${followerCount.toLocaleString("en-US")} ${followerText} to invite.`;

    const mobileActionsBar = (
        <div className="flex w-full flex-col gap-2">
            <CreateEventButton
                variant="default"
                user={user}
                communities={communities}
                size="sm"
                className="w-full"
            />
            <div className="flex w-full justify-between">
                <Link
                    href="https://getriver.notion.site/riverlivingroom"
                    className="text-sm hover:underline"
                >
                    Read our host guide
                </Link>
            </div>
        </div>
    );

    const actionsBar = (
        <>
            <CreateEventButton
                variant="default"
                user={user}
                communities={communities}
                size="sm"
            />

            <Link
                href="https://getriver.notion.site/riverlivingroom"
                target="_blank"
                className="text-sm hover:underline"
            >
                Read our host guide
            </Link>
        </>
    );

    const squareIcon = <CalendarCheckIcon className="h-[72px] w-[72px]" />;

    return (
        <SharedHomeHeader
            title={title}
            smallTitle={smallTitle}
            subTitle={subTitle}
            smallSubTitle={smallSubTitle}
            actionsBar={actionsBar}
            mobileActionsBar={mobileActionsBar}
            squareColor="#CEBDF1"
            squareIcon={squareIcon}
        />
    );
};

const getFollowerText = (count: number): string => {
    return count === 1 ? "follower" : "followers";
};

export default EventsHeader;
